var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { CommonUtils } from "@contenteditor-shared/content-editor-common/src/Utils/CommonUtils";
import { CommonAttributes, DismissPageHeaderNotificationEvent, EntityNames, JourneyAttributes, JourneyDependencyAttributes, LocalizationKeys } from "./Common/Constants";
export function transitToReadyToSend(formContext, entityDescriptor, onTransitionend) {
    if (onTransitionend === void 0) { onTransitionend = null; }
    var statusCode = formContext.getAttribute(CommonAttributes.status);
    var originalStatusCodeValue = statusCode.getValue();
    statusCode.setValue(entityDescriptor.readyToSendStatusCode);
    statusCode.fireOnChange();
    formContext.data.save().then(function () {
        !!onTransitionend && onTransitionend();
    }, function () {
        statusCode.setValue(originalStatusCodeValue);
        statusCode.fireOnChange();
    });
}
export function getJourneyDependencies(dependentEntityName, dependentEntityId) {
    return __awaiter(this, void 0, void 0, function () {
        var liveJourneys, nonLiveJourneys, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, getLiveDependentJourneys(dependentEntityName, dependentEntityId)];
                case 1:
                    liveJourneys = _a.sent();
                    return [4 /*yield*/, getNonLiveDependentJourneys(dependentEntityName, dependentEntityId)];
                case 2:
                    nonLiveJourneys = _a.sent();
                    return [2 /*return*/, {
                            liveJourneys: liveJourneys,
                            nonLiveJourneys: nonLiveJourneys
                        }];
                case 3:
                    e_1 = _a.sent();
                    return [2 /*return*/, null];
                case 4: return [2 /*return*/];
            }
        });
    });
}
export function getDependencyEntityFetchXml(dependentEntityName, dependentEntityId, journeyFilter) {
    var journeyAlias = "journey";
    return "<fetch>\n                <entity name='".concat(EntityNames.msdynmkt_journeydependency, "'>\n                    <link-entity name='").concat(JourneyDependencyAttributes.msdynmkt_journey, "' to='").concat(JourneyDependencyAttributes.msdynmkt_journey, "' alias='").concat(journeyAlias, "'>\n                        <attribute name='").concat(JourneyAttributes.msdynmkt_name, "' />\n                        <attribute name='").concat(JourneyAttributes.msdynmkt_journeystarttime, "' />\n                        <attribute name='").concat(JourneyAttributes.msdynmkt_journeyendtime, "' />\n                        <attribute name='").concat(JourneyAttributes.msdynmkt_journeyid, "' />\n                        <attribute name='").concat(CommonAttributes.status, "' />\n                        ").concat(journeyFilter || "", "\n                    </link-entity>\n                    <link-entity name='").concat(dependentEntityName, "' to='").concat(JourneyDependencyAttributes.msdynmkt_dependency, "'>\n                        <attribute name='").concat(dependentEntityName, "id' />\n                        <filter type='and'>\n                            <condition attribute='").concat(dependentEntityName, "id' operator='eq' value='").concat(dependentEntityId, "' />\n                        </filter>\n                    </link-entity>\n                </entity>\n            </fetch>");
}
export function getLiveDependentJourneys(dependentEntityName, dependentEntityId) {
    return __awaiter(this, void 0, void 0, function () {
        var filter, result, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    filter = "<filter type='and'>\n                        <condition attribute='".concat(CommonAttributes.status, "' operator='eq' value='2' />\n                    </filter>");
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, window.Xrm.WebApi.retrieveMultipleRecords(EntityNames.msdynmkt_journeydependency, "?fetchXml=" + encodeURIComponent(getDependencyEntityFetchXml(dependentEntityName, dependentEntityId, filter)))];
                case 2:
                    result = _a.sent();
                    return [2 /*return*/, mapResultsToJourneyEntityDescriptor(result)];
                case 3:
                    e_2 = _a.sent();
                    return [2 /*return*/, []];
                case 4: return [2 /*return*/];
            }
        });
    });
}
export function getNonLiveDependentJourneys(dependentEntityName, dependentEntityId) {
    return __awaiter(this, void 0, void 0, function () {
        var filter, result, e_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    filter = "<filter type='and'>\n                        <condition attribute='".concat(CommonAttributes.status, "' operator='ne' value='2' />\n                    </filter>");
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, window.Xrm.WebApi.retrieveMultipleRecords(EntityNames.msdynmkt_journeydependency, "?fetchXml=" + encodeURIComponent(getDependencyEntityFetchXml(dependentEntityName, dependentEntityId, filter)))];
                case 2:
                    result = _a.sent();
                    return [2 /*return*/, mapResultsToJourneyEntityDescriptor(result)];
                case 3:
                    e_3 = _a.sent();
                    return [2 /*return*/, []];
                case 4: return [2 /*return*/];
            }
        });
    });
}
export function mapResultsToJourneyEntityDescriptor(result) {
    var journeyAlias = "journey";
    return result["entities"].map(function (entity) { return ({
        name: entity["".concat(journeyAlias, ".").concat(JourneyAttributes.msdynmkt_name)],
        status: entity["".concat(journeyAlias, ".").concat(CommonAttributes.status)],
        startDate: entity["".concat(journeyAlias, ".").concat(JourneyAttributes.msdynmkt_journeystarttime)],
        endDate: entity["".concat(journeyAlias, ".").concat(JourneyAttributes.msdynmkt_journeyendtime)],
        id: entity["".concat(journeyAlias, ".").concat(JourneyAttributes.msdynmkt_journeyid)]
    }); });
}
export function dismissDependencyPageNotification() {
    CommonUtils.getTopWindow().dispatchEvent(new CustomEvent(DismissPageHeaderNotificationEvent, {
        detail: {
            text: LocalizationKeys.LiveJourneyNotificationTextWarning
        }
    }));
}
export function getLiveDependentJourneysDataDemand(dependentEntityName, dependentEntityId, includeFormerlyLiveJourneys) {
    return __awaiter(this, void 0, void 0, function () {
        var filter, result, e_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    filter = includeFormerlyLiveJourneys
                        ? "<filter type='and'>\n                <condition attribute='".concat(CommonAttributes.status, "' operator='neq' value='1' />\n                <condition attribute='").concat(CommonAttributes.status, "' operator='neq' value='4' />\n            </filter>")
                        : "<filter type='and'>\n                <condition attribute='".concat(CommonAttributes.status, "' operator='eq' value='2' />\n            </filter>");
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, window.Xrm.WebApi.retrieveMultipleRecords(EntityNames.msdynmkt_journeydependency, "?fetchXml=" + encodeURIComponent(getDependencyEntityFetchXmlForDataDemand(dependentEntityName, dependentEntityId, filter)))];
                case 2:
                    result = _a.sent();
                    return [2 /*return*/, mapResultsToJourneyEntityDataDemandFlags(result)];
                case 3:
                    e_4 = _a.sent();
                    return [2 /*return*/, []];
                case 4: return [2 /*return*/];
            }
        });
    });
}
function getDependencyEntityFetchXmlForDataDemand(dependentEntityName, dependentEntityId, journeyFilter) {
    var journeyAlias = "journey";
    var dependentAttributeName = "".concat(dependentEntityName, "id");
    return "<fetch>\n                <entity name='".concat(EntityNames.msdynmkt_journeydependency, "'>\n                    <link-entity name='").concat(JourneyDependencyAttributes.msdynmkt_journey, "' to='").concat(JourneyDependencyAttributes.msdynmkt_journey, "' alias='").concat(journeyAlias, "'>\n                        <attribute name='").concat(JourneyAttributes.msdynmkt_journeyid, "' />\n                        <attribute name='").concat(JourneyAttributes.msdynmkt_flags, "' />\n                        <attribute name='").concat(CommonAttributes.status, "' />\n                        ").concat(journeyFilter || "", "\n                    </link-entity>\n                    <link-entity name='").concat(dependentEntityName, "' to='").concat(JourneyDependencyAttributes.msdynmkt_dependency, "'>\n                        <attribute name='").concat(dependentAttributeName, "' />\n                        <filter type='and'>\n                            <condition attribute='").concat(dependentAttributeName, "' operator='eq' value='").concat(dependentEntityId, "' />\n                        </filter>\n                    </link-entity>\n                </entity>\n            </fetch>");
}
export function mapResultsToJourneyEntityDataDemandFlags(result) {
    var journeyAlias = "journey";
    return result["entities"].map(function (entity) { return ({
        flags: entity["".concat(journeyAlias, ".").concat(JourneyAttributes.msdynmkt_flags)],
        id: entity["".concat(journeyAlias, ".").concat(JourneyAttributes.msdynmkt_journeyid)]
    }); });
}
